/* Boutons son / lecture des cartes vidéo (sections avec [data-wh-videos]).
   - Seules les vidéos visibles tournent ; une vidéo mise en pause à la main ne repart pas seule.
   - Activer le son d'une vidéo coupe toutes les autres. */
(function () {
  /* La vidéo n'est téléchargée qu'à son arrivée à l'écran (src posé depuis data-src). */
  function charger(v) { if (!v.getAttribute("src") && v.dataset.src) v.src = v.dataset.src; }
  function lire(v) { if (window.whVideosCoupees) return; charger(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function monter(racine) {
    if (racine.__whVideos) return;
    racine.__whVideos = true;
    var videos = Array.prototype.slice.call(racine.querySelectorAll("video"));
    if (!videos.length) return;

    function carteDe(v) { return v.closest("[data-wh-carte-video]") || v.parentNode; }
    function maj(v) {
      var carte = carteDe(v);
      var bs = carte.querySelector("[data-qt-son]"), bl = carte.querySelector("[data-qt-lecture]");
      if (bs) {
        bs.setAttribute("data-etat", v.muted ? "off" : "on");
        bs.setAttribute("aria-pressed", String(!v.muted));
        bs.setAttribute("aria-label", v.muted ? "Activer le son" : "Couper le son");
      }
      if (bl) {
        bl.setAttribute("data-etat", v.paused ? "pause" : "lecture");
        bl.setAttribute("aria-label", v.paused ? "Lire la vidéo" : "Mettre en pause");
      }
    }
    videos.forEach(function (v) {
      ["play", "pause", "volumechange"].forEach(function (ev) { v.addEventListener(ev, function () { maj(v); }); });
      maj(v);
    });

    racine.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qt-son], [data-qt-lecture]");
      if (!b || !racine.contains(b)) return;
      e.preventDefault();
      e.stopPropagation();
      var v = carteDe(b).querySelector("video");
      if (!v) return;
      if (b.hasAttribute("data-qt-son")) {
        if (v.muted) {
          document.querySelectorAll("video").forEach(function (o) { if (o !== v) o.muted = true; });
          v.muted = false;
          v.__pauseManuelle = false;
          lire(v);
        } else {
          v.muted = true;
        }
      } else if (v.paused) {
        v.__pauseManuelle = false;
        lire(v);
      } else {
        v.__pauseManuelle = true;
        v.pause();
      }
    }, true);

    if ("IntersectionObserver" in window) {
      var obs = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { if (!v.__pauseManuelle) lire(v); }
          else v.pause();
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { obs.observe(v); });
    } else {
      videos.forEach(lire);
    }
  }

  function demarrer() { document.querySelectorAll("[data-wh-videos]").forEach(monter); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
  document.addEventListener("shopify:section:load", demarrer);
})();
